import { css } from "emotion";
import { Component } from "preact";
import { getCurrentUrl } from "preact-router";
import { Link } from "preact-router/match";
import BackButton from "./BackButton";

const min = len => `@media (min-width: ${len}px)`;
const max = len => `@media (max-width: ${len}px)`;

const stepItem = css({
  a: {
    color: "#323232",
    fontSize: 16
  },
  // css for screen width <700px
  [max(700)]: {
    ":not(:first-of-type)": {
      "::before": {
        content: `''`,
        display: "inline-block",
        width: 7,
        height: 7,
        margin: "0px 7px 2px 8.6px",
        borderTop: "2px solid #788391",
        borderRight: "2px solid #788391",
        backgroundColor: "white",
        transform: "rotate(45deg)"
      }
    },
    display: "inline-block",
    "#step-desktop": {
      display: "none"
    },
    "#step-mobile": {
      display: "inline-block"
    }
  },
  // css for screen width >700px
  [min(700)]: {
    "&::before": {
      content: `counter(li)`,
      width: 24,
      height: 24,
      marginRight: 4,
      display: "inline-block",
      color: "white",
      borderRadius: "100%",
      lineHeight: "23px",
      backgroundColor: "#323232"
    },
    "&::after": {
      content: `''`,
      backgroundColor: "#dedede",
      verticalAlign: "middle",
      position: "relative",
      left: 8,
      width: 20,
      height: 1,
      marginRight: 16,
      display: "inline-block"
    },
    ":last-child": {
      ":after": {
        display: "none"
      }
    },
    counterIncrement: "li",
    display: "inline-block"
  }
});

const disabled = css({
  "&::before": {
    backgroundColor: "rgb(169, 164, 174)"
  },
  color: "#a9a4ae"
});

const processSteps = css({
  display: "inline-block",
  margin: "0",
  padding: "0.2rem 0"
});

const pipeStyle = css({
  marginRight: "0.4rem",
  color: "rgba(153, 153, 153, 0.85)"
});

const wrapper = css({
  marginBottom: 20,
  marginRight: "auto",
  marginLeft: "auto",
  marginTop: 8,
  [max(700)]: {
    marginTop: 0,
    marginBottom: 8
  }
});

const desktopLabel = css({
  display: "inline-block",
  [max(700)]: {
    display: "none"
  }
});

const mobileLabel = css({
  display: "none",
  [max(700)]: {
    display: "inline-block"
  }
});

class Steps extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    try {
      this.isWidget = false;
      const isBrowser = typeof window !== "undefined";
      if (isBrowser && window.self !== window.top) {
        this.isWidget = true;
      }
      if (!this.isWidget) {
        // do not force focus on the widget as it causes the page to scroll
        document.getElementById("activeLink").focus();
      }
    } catch (err) {}
  }

  render() {
    let {
      theme,
      eventSlug,
      orderId,
      includeSeatingMap,
      includesMerch,
      isConference
    } = this.props;

    const primaryColor =
      theme && theme.primaryColor ? theme.primaryColor : "#6621c0";

    const defaultStyle = css({
      "&::before": {
        backgroundColor: primaryColor
      }
    });

    const active = css({
      "&::before": {
        backgroundColor: primaryColor
      },
      fontWeight: "600",
      a: {
        color: primaryColor
      }
    });

    let steps = [
      {
        label: "Select Tickets",
        mobileLabel: "Tickets",
        path: `/${eventSlug}/tickets`
      },
      {
        label: `${isConference ? "Buyer" : "Enter"} Details`,
        mobileLabel: "Details",
        path: `/${eventSlug}/details/${orderId}`
      },
      {
        label: "Payment",
        mobileLabel: "Payment",
        path: `/${eventSlug}/payment/${orderId}`
      }
    ];
    if (includeSeatingMap) {
      steps.splice(2, 0, {
        label: "Seats",
        mobileLabel: "Seats",
        path: `/${eventSlug}/seatingmap/${orderId}`
      });
    }

    if (includesMerch) {
      steps.splice(1, 0, {
        label: "Add Ons",
        mobileLabel: "Add Ons",
        path: `/${eventSlug}/add-ons/${orderId}`
      });
    }

    if (isConference) {
      steps.splice(steps.length - 1, 0, {
        label: "Assign Tickets",
        mobileLabel: "Assign",
        path: `/${eventSlug}/assign/${orderId}`
      });
    }

    const isBrowser = typeof window !== "undefined";
    let isWidget = false;
    if (isBrowser && window.self !== window.top) {
      isWidget = true;
    }

    const url = getCurrentUrl();
    const path = url.replace(/\?.+$/, "");

    let matched = false;
    steps.forEach((step, index) => {
      step.ref = step.path.replace("/", "-").toLowerCase();
      if (matched) {
        step.disabled = true;
      }
      if (path.indexOf(step.path) !== -1) {
        step.active = true;
        matched = true;
      }
    });

    return (
      <div className={wrapper}>
        {/* <span>Steps in process:</span> */}
        <ul className={processSteps}>
          {isWidget ? (
            <span>
              <BackButton />
              <span className={pipeStyle}>|</span>
            </span>
          ) : null}
          {steps.map((step, index) => {
            const classes = [stepItem];
            if (step.active) {
              classes.push(active);
            } else if (step.disabled) {
              classes.push(disabled);
            } else {
              classes.push(defaultStyle);
            }
            return (
              <li key={index} className={css(classes)}>
                {!step.disabled ? (
                  <Link
                    href={step.path}
                    id={step.active ? "activeLink" : "disabled"}
                    aria-current={step.active ? "step" : null}
                  >
                    <div class="sr-only">Step {index + 1}</div>
                    <div className={desktopLabel}>{step.label}</div>
                    <div className={mobileLabel}>{step.mobileLabel}</div>
                  </Link>
                ) : (
                  <div style={{ display: "inherit" }}>
                    <div className={desktopLabel}>{step.label}</div>
                    <div className={mobileLabel}>{step.mobileLabel}</div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
export default Steps;



// WEBPACK FOOTER //
// ./components/Steps.js